import { Button } from "@mui/material";
import RenderAmount from "src/components/Table/components/RenderAmount";
import RenderCell from "src/components/Table/components/RenderCell";
import RenderCopy from "src/components/Table/components/RenderCopy";
import RenderDate from "src/components/Table/components/RenderDate";
import {
  TableControlConfigItem,
  TableControls,
} from "src/features/tableControls/tableControls";

export const tableControlsConfig: TableControlConfigItem[] = [
  {
    field: "id",
    headerName: "ID",
    flex: 1,
    filterable: true,
    sortable: false,
    fieldType: "text",
    renderCell: (params) => <RenderCopy val={params} />,
  },
  {
    field: "userId",
    headerName: "User ID",
    flex: 1,
    filterable: true,
    sortable: false,
    fieldType: "text",
    renderCell: (row) => <RenderCopy val={row} />,
  },
  {
    field: "amount",
    headerName: "Amount",
    flex: 1,
    filterable: false,
    sortable: false,
    fieldType: "text",
    renderCell: (row) => <RenderAmount val={row} />,
  },
  {
    field: "transactionStatus",
    headerName: "Status",
    flex: 1,
    filterable: false,
    sortable: false,
    fieldType: "text",
    renderCell: (row) => <RenderCell val={row} />,
  },
  {
    field: "createdAt",
    headerName: "Created",
    flex: 1,
    filterable: false,
    fieldType: "date",
    renderCell: (params) => <RenderDate val={params} withTime />,
  },
  {
    field: "revertTrade",
    headerName: "Revert Trade",
    flex: 1,
    filterable: false,
    sortable: false,
    fieldType: "text",
    renderCell: () => <Button id="revert-button">Revert trade</Button>,
  },
];

export const tableControls = new TableControls(tableControlsConfig);
